import React, { useState, useContext, useEffect } from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import "../styles/Contact.css";
import { AuthContext } from "../context/AuthContext";
import { WebSocketContext } from '../context/WebSockectContext';

const Contact = () => {
  const { token } = useContext(AuthContext); 
  const { sendMessage, contactMessage, ws } = useContext(WebSocketContext); 

  const [formData, setFormData] = useState({
    name: "",
    subject: "",
    email: "",
    phone: "",
    message: "",
  });

  const [formStatus, setFormStatus] = useState("");

  // Update form status when a contact_message_response is received
  useEffect(() => {
    if (contactMessage) {
      if (contactMessage.status === "success") {
        setFormStatus("Message sent successfully!");
        setFormData({
          name: "",
          subject: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        setFormStatus("Failed to send message. Please try again.");
      }
    }
  }, [contactMessage]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Validation checks
    if (!formData.name || !formData.email || !formData.message) {
      setFormStatus("Please fill in all required fields.");
      return;
    }
  
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(formData.email)) {
      setFormStatus("Please enter a valid email address.");
      return;
    }
  
    const messagePayload = {
      type: "contact_message",
      token, 
      formData,
    };
  
    try {
      sendMessage(JSON.stringify(messagePayload)); 
      setFormStatus("Message sent successfully!");
    } catch (error) {
      setFormStatus("Failed to send message. Please try again.");
    }
  };
  
  return (
    <div className="contact-container">
      <h2 className="text-2xl font-bold mb-4">Contact HuntexLotto</h2>
      <p className="text-2xl font-bold mb-4">
        We’re here for you 24/7, contact our support team to get started today! For any questions, comments or suggestions regarding our lottery service.
      </p>
      <div className="flex flex-col md:flex-row gap-8">
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-row">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              className="input-field"
              required
            />
            <input
              type="text"
              name="subject"
              placeholder="Your Subject"
              value={formData.subject}
              onChange={handleChange}
              className="input-field"
            />
          </div>
          <div className="form-row">
            <input
              type="email"
              name="email"
              placeholder="Mail Address"
              value={formData.email}
              onChange={handleChange}
              className="input-field"
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              className="input-field"
            />
          </div>
          <textarea
            name="message"
            placeholder="Write a Message"
            value={formData.message}
            onChange={handleChange}
            className="text-area"
            required
          ></textarea>
          <button type="submit" className="submit-button">
            Send Message
          </button>
          {formStatus && (
            <p className={`mt-2 ${formStatus.includes("success") ? "text-green-500" : "text-red-500"}`}>
              {formStatus}
            </p>
          )}
        </form>
        <div className="md:w-1/3">
          <div className="office-address">
            <h2>Our Office Address</h2>
            <div className="space-y-2">
              <p className="office-contact">
                <MapPin size={20} />
                Address: GA-0014-001, Accra, Ghana.
              </p>
              <p>
                Web:{" "}
                <a href="http://www.huntexlotto.com" className="text-pink-600 underline">
                  www.huntexlotto.com
                </a>
              </p>
              <p className="office-contact">
                <Phone size={20} />
                (+233) 055 7327038
                (+233) 024 3209725
              </p>
              <p className="office-contact">
                <Mail size={20} />
                <a href="mailto:huntexghgame@gmail.com" className="text-pink-600 underline">
                huntexlotto.com@huntexlotto.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
